import { render, staticRenderFns } from "./upairy-compare-card.vue?vue&type=template&id=fdb2184e&scoped=true&"
import script from "./upairy-compare-card.vue?vue&type=script&lang=js&"
export * from "./upairy-compare-card.vue?vue&type=script&lang=js&"
import style0 from "./upairy-compare-card.vue?vue&type=style&index=0&id=fdb2184e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb2184e",
  null
  
)

export default component.exports